/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OrderType = {
    MARKET: 'MARKET',
    LIMIT: 'LIMIT'
} as const;
export type OrderType = typeof OrderType[keyof typeof OrderType];


export function instanceOfOrderType(value: any): boolean {
    for (const key in OrderType) {
        if (Object.prototype.hasOwnProperty.call(OrderType, key)) {
            if (OrderType[key as keyof typeof OrderType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OrderTypeFromJSON(json: any): OrderType {
    return OrderTypeFromJSONTyped(json, false);
}

export function OrderTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderType {
    return json as OrderType;
}

export function OrderTypeToJSON(value?: OrderType | null): any {
    return value as any;
}

export function OrderTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): OrderType {
    return value as OrderType;
}

